import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SCREENS } from '../../services/exports/Constants';
import React from 'react';
import useRouter from '../../hooks/navigation/useRouter';

export default function TermsLink({ termsUrl, privacyPolicyUrl }: { termsUrl?: string; privacyPolicyUrl?: string }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Legal:TermsLink' });

  const { generatePath } = useRouter();

  const _termsUrl = termsUrl ?? generatePath(SCREENS.TERMS_AND_CONDITIONS);
  const _privacyPolicyUrl = privacyPolicyUrl ?? generatePath(SCREENS.PRIVACY_POLICY);

  return (
    <p className="lg:mt-lg mt-md text-xs text-muted-foreground">
      <Trans
        t={t}
        components={{
          TermsLink: <Link to={_termsUrl} target="_blank" className="underline" />,
          PrivacyPolicyLink: <Link to={_privacyPolicyUrl} target="_blank" className="underline" />,
        }}
      >
        terms
      </Trans>
    </p>
  );
}
